"use strict";

var _objectSpread = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _wrapRegExp = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/wrapRegExp.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatAbiParameter = void 0;
const regex_js_1 = require("../regex.js");
const tupleRegex = /*#__PURE__*/_wrapRegExp(/^tuple((\[(\d*)\])*)$/, {
  array: 1
});
function formatAbiParameter(abiParameter) {
  let type = abiParameter.type;
  if (tupleRegex.test(abiParameter.type) && 'components' in abiParameter) {
    var _result$array;
    type = '(';
    const length = abiParameter.components.length;
    for (let i = 0; i < length; i++) {
      const component = abiParameter.components[i];
      type += formatAbiParameter(component);
      if (i < length - 1) type += ', ';
    }
    const result = (0, regex_js_1.execTyped)(tupleRegex, abiParameter.type);
    type += ")".concat((_result$array = result === null || result === void 0 ? void 0 : result.array) !== null && _result$array !== void 0 ? _result$array : '');
    return formatAbiParameter(_objectSpread(_objectSpread({}, abiParameter), {}, {
      type
    }));
  }
  if ('indexed' in abiParameter && abiParameter.indexed) type = "".concat(type, " indexed");
  if (abiParameter.name) return "".concat(type, " ").concat(abiParameter.name);
  return type;
}
exports.formatAbiParameter = formatAbiParameter;
//# sourceMappingURL=formatAbiParameter.js.map